(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kraveon-catalogue-tile')) {
    customElements.define('kraveon-catalogue-tile', class extends HTMLElement {
      connectedCallback() {
        const section = this.closest('.shopify-section');
        const gallery = section?.querySelector('.resource-list__item .card-gallery');
        const card = gallery?.closest('.resource-list__item');
        if (!gallery || !card) return;
        const sync = () => {
          const media = gallery.getBoundingClientRect();
          const parent = card.getBoundingClientRect();
          if (media.height > 0) {
            this.style.setProperty('--catalogue-height', media.height + 'px');
            this.style.setProperty('--catalogue-offset', Math.max(0, media.top - parent.top) + 'px');
          }
        };
        this.observer = new ResizeObserver(sync);
        this.observer.observe(gallery);
        this.observer.observe(card);
        sync();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
